import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const CERTIFICATIONCODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CertificationCode.Name')
    .required()
    .minLength(1)
    .maxLength(25)
    .build(),
];

export const CERTIFICATIONCODE_CONFIG = {
  entityName: 'CertificationCode',
  localizationKey: 'Planning::Entity.CertificationCode',
  fields: CERTIFICATIONCODE_FIELDS,
  permission: 'PlanningCertification.CertificationCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
